import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import PhoneCodeInputStore from './store';
import PhoneInput from '../../components/phone-input';
import TinyInput from '../../components/tiny-input';
import SmsCodeInput from '../../components/sms-code-input';
const styles = require('./index.less');

const PhoneCodeInput = ({ store }) => {
  store.use();
  return (
    <div className={styles.container}>
      <div className={styles.inputWrap}>
        <PhoneInput placeholder="请输入手机号" store={store.phoneInputStore} className={styles.phoneInput} />
      </div>
      <div className={cx(styles.inputWrap, styles.codeInputWrap)}>
        <div className={styles.inputWrap}>
          <TinyInput placeholder="请输入验证码" store={store.smsInputStore} className={styles.codeInput} />
        </div>
        <div>
          <SmsCodeInput
            countdownChange={store.countdownChange}
            codeBtnClassName={cx(styles.codeBtn)}
            // codeBtnClassName={cx(styles.codeBtn)}
            phone={store.phoneInputStore.value}
            buttonText={''}
            sendCode={store.onSendVCRequest}
          />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(PhoneCodeInput, PhoneCodeInputStore);
